
export function sleep (time: number) {
  return new Promise((resolve) => setTimeout(resolve, time))
}

export class PromiseController<T = unknown> {
  protected _resolve: (v: T) => void
  protected _reject: (e: any) => void
  public promise: Promise<T>

  constructor (
    fn: (resolve: (r: any) => void, reject: (e: any) => void) => void = () => { },
  ) {
    let resolveFunction
    let rejectFunction

    this.promise = new Promise((resolve, reject) => {
      resolveFunction = resolve
      rejectFunction = reject
      fn(resolve, reject)
    })
    this._resolve = resolveFunction as any
    this._reject = rejectFunction as any
  }

  resolve (value: T) {
    this._resolve(value)
  }

  reject (error: any) {
    this._reject(error)
  }
}

